import { IFinanceDocuments } from 'types';
import { IFundingRisk } from '../../types';

export const isFundingRisk = (risks: IFundingRisk[], riskName: string, id: string): boolean => {
  return risks.some(risk => risk.id === id && risk?.risks.includes(riskName));
};

export const hasFundingRisks = (risks: IFundingRisk[], id: string): boolean => {
  const foundDoc = risks.find(docRisk => docRisk.id === id);
  return foundDoc !== undefined && foundDoc.risks.length > 0;
};

export const hasFinDocsRisks = (docs: Partial<IFinanceDocuments>, risks: IFundingRisk[]): boolean => {
  for (const item of risks) {
    const currentDocs = docs[item.id as keyof IFinanceDocuments];
    if (typeof currentDocs === 'object' && currentDocs?.status !== 'UPLOADED_WITH_ERROR') {
      continue;
    }
    if (hasFundingRisks(risks, item.id)) {
      return true;
    }
  }
  return false;
};

export const hasNoRisks = (risks: IFundingRisk[]): boolean => {
  const foundRisks = risks.filter(docRisk => docRisk.risks.length > 0);
  return risks.length === 0 || foundRisks.length === 0;
};

export const isAllRisksCleared = (
  docs: Partial<IFinanceDocuments> | null,
  risks: IFundingRisk[],
  clearedRisks: IFundingRisk[],
): boolean => {
  for (const item of risks) {
    if (hasFundingRisks(risks, item.id)) {
      const foundDoc = clearedRisks.find(docRisk => docRisk.id === item.id);

      const currentDocs = docs?.[item.id as keyof IFinanceDocuments];
      if (typeof currentDocs === 'object' && currentDocs?.status !== 'UPLOADED_WITH_ERROR') {
        continue;
      }

      if (foundDoc === undefined || foundDoc.risks.length !== item.risks.length) {
        return false;
      }
    }
  }

  return true;
};
